import React from 'react';

/**
 * La carte de réglages : l'unité de base d'une page de paramétrage.
 *
 * Un groupe de réglages qui vont ensemble, sous un titre qui nomme le groupe.
 *
 * Elle existe en composant pour la même raison que l'en-tête : chaque page
 * avait inventé son propre encadré — `Card border-0 shadow-sm`, `bg-gray-50
 * p-4 rounded-lg`, `bg-white border rounded-lg shadow-sm` — et aucun ne
 * ressemblait au suivant.
 *
 * La norme : PARAMETRAGE-MODULES.md §4.
 *
 * @param titre     nom du groupe, rendu en capitales.
 * @param accent    la couleur de la barre verticale, seul repère coloré.
 * @param compteur  ce qui s'affiche à droite du titre : un décompte, jamais
 *                  un bouton d'action.
 * @param dense     `true` sépare les enfants par `divide-y` (liste de
 *                  réglages) ; `false` laisse un bloc libre avec sa marge.
 */
const CarteReglages = ({
  titre,
  accent = '#246990',
  compteur,
  dense = false,
  children,
}) => (
  <div className="bg-white rounded-xl border border-gray-200/80 overflow-hidden shadow-[0_1px_3px_rgba(0,0,0,0.04)]">
    <div className="px-5 py-3.5 border-b border-gray-100 flex items-center gap-3">
      <div className="w-2 h-8 rounded-full flex-shrink-0" style={{ backgroundColor: accent }} />
      <h3 className="font-bold text-[13px] text-gray-800 uppercase tracking-wide">{titre}</h3>
      {compteur !== undefined && compteur !== null && (
        <span className="ml-auto text-xs font-medium text-gray-400 bg-gray-50 px-2.5 py-1 rounded-md whitespace-nowrap">
          {compteur}
        </span>
      )}
    </div>

    <div className={dense ? 'divide-y divide-gray-50' : 'px-5 py-5'}>
      {children}
    </div>
  </div>
);

export default CarteReglages;
